import { Modal, Row, Col, Button, Form } from 'react-bootstrap'

import styles from './styles.module.css'
import { useState } from 'react'
import { IMaskInput } from 'react-imask'

function UpdateRequestWeightModal({ show, requestWeight, message, onClose, onSubmit }) {
  const [weightString, setWeightString] = useState(String(requestWeight).replace('.', ','))
  const [weight, setWeight] = useState(Number(requestWeight))

  return (
    <Modal centered show={show} onHide={onClose}>
      <Modal.Header closeButton />
      <Modal.Body>
        <p style={{ fontSize: 15, fontWeight: 500 }}>{message}</p>
        <Row
          style={{
            padding: 12,
            paddingTop: 3,
            textAlign: 'left',
          }}
        >
          <Form.Label className={styles.label}>Peso total do pedido (kg)*</Form.Label>
          <Form.Control
            className={styles.input}
            style={{ color: 'black' }}
            as={IMaskInput}
            mask={[
              {
                mask: Number,
                radix: ',',
              },
            ]}
            placeholder="Digite aqui o peso"
            value={weightString}
            onChange={(event) => {
              setWeightString(event.target.value)
              setWeight(Number(event.target.value.replace(',', '.')))
            }}
          />
        </Row>
        <Row style={{ padding: 4, paddingBottom: 4 }}>
          <Col style={{ padding: 8, paddingBottom: 4 }}>
            <Button className={`${styles.btnn} ${styles.btnnNo}`} onClick={onClose}>
              Cancelar
            </Button>
          </Col>
          <Col style={{ padding: 8, paddingBottom: 4 }}>
            <Button
              className={`${styles.btnn} ${styles.btnnYes}`}
              onClick={() => onSubmit(weight)}
              disabled={!weight}
            >
              Confirmar
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default UpdateRequestWeightModal
